import { create_org } from './create-org';
import { raise_invoice } from './raise-invoice';
import { purchase_subscription } from './purchase-subscription';

// Onboarding guides shown on the dashboard. `track` gates a guide to a partner
// track ('freelancer' | 'business'); a null track shows it to everyone. Each
// guide's `slides` is an array of { caption, image } shown in the guide modal.
export const GUIDES = [
  {
    id: 'create-org',
    title: 'Create an organisation',
    description: 'Set up a client organisation so you can manage their plan and billing.',
    track: null,
    slides: create_org
  },
  {
    id: 'raise-invoice',
    title: 'Raising an invoice',
    description: 'Bill a client for a plan and add your margin before sending the invoice.',
    track: 'freelancer',
    slides: raise_invoice
  },
  {
    id: 'purchase-subscription',
    title: 'Purchasing a subscription',
    description: 'Choose a plan and activate a subscription on a client’s behalf.',
    track: 'business',
    slides: purchase_subscription
  }
];

// Only the guides relevant to the partner's track (track-less guides always show).
export const getGuidesForTrack = (track) =>
  GUIDES.filter((guide) => !guide.track || guide.track === track);
